<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: { Layout },
  data() {
    return {
      loading: true,
      errored: false,
      lead: null,
    };
  },
  methods: {
    fetchLead() {
      this.loading = true;
      this.errored = false;
      const uuid = this.$route.params.id;

      api.get(`lead/${uuid}`)
        .then(res => {
          if (res.data && res.data.status === 'success') {
            this.lead = res.data.lead;
          } else {
            this.lead = null;
          }
        })
        .catch(e => { this.errored = e; })
        .finally(() => { this.loading = false; });
    }
  },
  mounted() {
    this.fetchLead();
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Detalhes do Lead</h3>
        <p class="text-muted m-0">{{ lead?.lead_date || '—' }}</p>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="errored" class="text-center text-danger">Falha ao carregar o lead.</div>
        <div v-else-if="loading" class="text-center text-muted">Carregando…</div>

        <div v-else-if="!lead" class="text-center text-muted">Lead não encontrado.</div>

        <div v-else class="lead-sections">
          <!-- Informações do Lead -->
          <section class="mb-4">
            <h5 class="section-title">Informações do Lead</h5>
            <div class="row">
              <div class="col-md-6 mb-2">
                <div class="label">Nome</div>
                <div class="value">{{ lead.lead_nome || '—' }}</div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="label">Email</div>
                <div class="value">{{ lead.lead_email || '—' }}</div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="label">Telefone</div>
                <div class="value">{{ lead.lead_telefone || '—' }}</div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="label">Estado</div>
                <div class="value">{{ lead.lead_estado || '—' }}</div>
              </div>
            </div>
          </section>

          <!-- Informações de Origem -->
          <section class="mb-4">
            <h5 class="section-title">Informações de Origem</h5>
            <div class="row">
              <div class="col-md-6 mb-2">
                <div class="label">Origem</div>
                <div class="value">{{ lead.lead_origem || '—' }}</div>
              </div>
              <div class="col-md-6 mb-2">
                <div class="label">Mídia</div>
                <div class="value">{{ lead.lead_midia || '—' }}</div>
              </div>
            </div>
          </section>

          <!-- Informações do Veículo -->
          <section class="mb-4">
            <h5 class="section-title">Informações do Veículo</h5>
            <div class="row">
              <div class="col-md-4 mb-2">
                <div class="label">Marca</div>
                <div class="value">{{ lead.lead_marca || '—' }}</div>
              </div>
              <div class="col-md-4 mb-2">
                <div class="label">Modelo</div>
                <div class="value">{{ lead.lead_modelo || '—' }}</div>
              </div>
              <div class="col-md-4 mb-2">
                <div class="label">Placa</div>
                <div class="value">{{ lead.lead_placa || '—' }}</div>
              </div>
            </div>
          </section>

          <!-- Mensagem do Lead -->
          <section class="mb-2">
            <h5 class="section-title">Mensagem do Lead</h5>
            <div class="value pre-wrap">{{ lead.lead_mensagem || '—' }}</div>
          </section>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.section-title {
  color: #0b2347;          /* azul marinho */
  font-weight: 700;        /* negrito */
  margin-bottom: .75rem;
}
.label {
  color: #0b2347;          /* azul marinho */
  font-weight: 700;        /* negrito */
  font-size: .9rem;
}
.value {
  color: #111;             /* preto normal */
  font-weight: 400;
}
.pre-wrap { white-space: pre-wrap; }
</style>
